var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 5,
    viewBox: "0 0 6 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20759 1.02937C2.6079 0.509357 3.3921 0.509358 3.79241 1.02937L5.22473 2.89001C5.73092 3.54757 5.26216 4.5 4.43232 4.5H1.56768C0.737838 4.5 0.269076 3.54757 0.775273 2.89001L2.20759 1.02937Z",
    fill: "#16AD77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPolygon);
export default __webpack_public_path__ + "static/media/green_polygon.390ed33cd3608358dbfdb5698b18287b.svg";
export { ForwardRef as ReactComponent };